<script setup>
import analyticEventKeys from '@/constants/analytic-event-keys';

const props = defineProps({
  // all search filters
  modelValue: {
    type: Object,
    default: () => ({}),
  },

  type: {
    type: String,
    required: true,
    validator(type) {
      return ['departure', 'arrival'].includes(type);
    },
  },

  withBack: {
    type: Boolean,
    default: false,
  },
  withAutofocus: {
    type: Boolean,
    default: true,
  },
});

const analytics = useGoogleAnalytics();

const emit = defineEmits(['close', 'back', 'success', 'update:modelValue']);

const { t } = useI18n();
const screenName = t(`form.${props.type}`);

const modelKey = computed(() => `${props.type}Station`);

const recentLocations = useRecentLocations();
async function emitUpdate(value) {
  await recentLocations.add(value.id);

  await analytics.pushEvent({
    event: analyticEventKeys.ENTER_SEARCH_DETAILS,
    label: `${props.type}: ${value?.id}`,
  });
  emit('update:modelValue', { [modelKey.value]: value });
  emit('success');
}

const oppositeLocationId = computed(() => {
  return props.type !== 'departure'
    ? props.modelValue.departureStation?.id
    : undefined;
});
</script>

<template>
  <FormsSearchScreenWrapper
    class="forms-search-screens-station"
    :name="screenName"
    :departure-name="modelValue.departureStation?.name"
    :arrival-name="modelValue.arrivalStation?.name"
    :with-back="withBack"
    @close="emit('close')"
    @back="emit('back')"
  >
    <BundlesStationSelect
      class="forms-search-screens-station__select"
      :placeholder="screenName"
      :station-name="modelValue[modelKey]?.name || ''"
      :opposite-location-id="oppositeLocationId"
      :model-value="modelValue"
      :type="type"
      :with-autofocus="withAutofocus"
      @select="emitUpdate"
      @clear="emit('update:modelValue', null)"
    />
  </FormsSearchScreenWrapper>
</template>

<style scoped lang="scss">
.forms-search-screens-station {
  &__select {
    height: 100%;
  }
}
</style>
